/**
 * Check if a given object implements the AssignUnitFilterToSelfLearningUnitRequest interface.
 */
export function instanceOfAssignUnitFilterToSelfLearningUnitRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "unitFilterId" in value;
    return isInstance;
}
export function AssignUnitFilterToSelfLearningUnitRequestFromJSON(json) {
    return AssignUnitFilterToSelfLearningUnitRequestFromJSONTyped(json, false);
}
export function AssignUnitFilterToSelfLearningUnitRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unitFilterId': json['unitFilterId'],
    };
}
export function AssignUnitFilterToSelfLearningUnitRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'unitFilterId': value.unitFilterId,
    };
}
